<template>
  <skud-command-form />
</template>

<script>
import SkudCommandForm from '@/views/skud/components/SkudCommandForm.vue'

export default {
  name: 'SkudCommandPage',
  components: { SkudCommandForm }
}
</script>
